import { createSelector } from 'reselect';
import { getLocalizedString, sortByProperty } from '@synergy/utils';

import { AppState } from '../../store/models/app-state';
import { Eclass } from '../models/eclass';
import { localesSelector } from './locale-selectors';

const eclassState = (state: AppState) => state.eclass;

export const eclassSelector = createSelector([eclassState, localesSelector], (eclasses, locales) =>
    sortByProperty({
        data: eclasses.eclasses,
        key: 'position',
        sortDirection: 'asc',
    }).map<Eclass>(eclass => ({
        id: eclass.position,
        name: getLocalizedString(locales, eclass.name),
        label: `${eclass.position / 1000000}  ${getLocalizedString(locales, eclass.name)}`,
    }))
);
